import { isRouteError, RouteError } from '@/utils/RouteError';
import { ZodError } from 'zod';
import { IRouteErrorResponse } from '@/interfaces/IRouteErrorResponse';
import { NextResponse } from 'next/server';

export function responseBodyForRouteError(routeError: RouteError): IRouteErrorResponse {
  return {
    name: routeError.name,
    isRouteErrorResponse: true,
    error: routeError.message,
    fieldErrors: routeError.fieldErrors,
  };
}
export function nextResponseForRouteError(routeError: RouteError): NextResponse<IRouteErrorResponse> {
  return NextResponse.json(responseBodyForRouteError(routeError), {
    status: routeError.status,
  });
}

export function routeErrorForError(error: unknown) {
  if (error instanceof ZodError) {
    return RouteError.fromZodError(error);
  }

  if (isRouteError(error)) {
    return error;
  }

  return new RouteError(
    {
      error: (error as Error).message,
    },
    500,
  );
}

export function nextResponseForError(error: unknown): Response {
  const routeError = routeErrorForError(error);
  return nextResponseForRouteError(routeError);
}
